<form [formGroup]="userForm" class="container-fluid">
  <h1 mat-dialog-title>Create Passenger</h1>
  <mat-dialog-content class="row">
    <mat-form-field class="col-12">
      <input matInput required placeholder="Legal First Name" formControlName="firstName" />
    </mat-form-field>
    <mat-form-field class="col-12">
      <input matInput required placeholder="Legal Last Name" formControlName="lastName" />
    </mat-form-field>
    <mat-form-field class="col-12">
      <input matInput placeholder="Email" formControlName="emailAddress" />
      <mat-error>
        <sd-validation-messages [control]="userForm.controls['emailAddress']">
        </sd-validation-messages>
      </mat-error>
    </mat-form-field>
    <div *ngIf="errorMsg" class="col-12">
      <mat-error>{{ errorMsg }}</mat-error>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close (click)="cancel()">Cancel</button>
    <button class="mat-raised-button mat-primary" [disabled]="userForm.invalid" (click)="submit()">
      Save
    </button>
  </mat-dialog-actions>
</form>
